import { createSelector } from "reselect";

import { getIsSavingCreditCard as getIsSavingCreditCardEntity } from "store/entities/credit-card/selectors";
import { selectIsAddingSubscription } from "store/entities/subscriptions";

export const getIsSavingCreditCard = createSelector(
  getIsSavingCreditCardEntity,
  selectIsAddingSubscription,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (isSavingCreditCard: any, isAddingSubscription: any) => isSavingCreditCard || isAddingSubscription
);
